import { ValidatorStates } from '@chegg-wt/core/state/citation/constants'
import { Citation } from '@chegg-wt/core/types/redux-citation-api'
import { EnumLiteralsOf } from '@chegg-wt/core/types/helpers'
import { AutociteMetadataInput } from '@chegg-wt/core/globalTypesOneGraph'
import { CitationMetadata } from '@chegg-wt/core/types/autocite'

export type ValidatorState = EnumLiteralsOf<typeof ValidatorStates>

export interface CitationState {
  isNew: boolean
  validatorStatus: string
  // TODO: add type to activeCitation
  activeCitation: any
  autociteRioTrackingID?: string | null
  autociteResponseForRio?: AutociteMetadataInput | null
  citationInProgress: number[]
  showErrorToast: boolean
}

export interface CitationStatus {
  id: string
  status: ValidatorState
}

export interface CitationSuccessPayload {
  citation: Citation
  navigate?: boolean
  citationMetadata?: CitationMetadata
}

export enum AddRemoveCitationInProgress {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  REMOVE_ALL = 'REMOVE_ALL',
}
